/* --------------------------------------------------------
   quiz.js — Final Enhanced Version
   --------------------------------------------------------
   Features:
   ✔ Multi-step quiz navigation
   ✔ Original Babymama result logic
   ✔ Shopify product fetching (/products/<handle>.js)
   ✔ Variant selector dropdown
   ✔ Add-to-cart button (AJAX)
   ✔ Improved UI styling hooks
--------------------------------------------------------- */

document.addEventListener('DOMContentLoaded', function() {

  // DOM elements
  const q1 = document.getElementById('question1');
  const q2 = document.getElementById('question2');
  const q3 = document.getElementById('question3');
  const note = document.getElementById('note');
  const resultsContainer = document.getElementById('quizresults');

  // Initialize
  q1.style.display = '';
  q2.style.display = 'none';
  q3.style.display = 'none';
  resultsContainer.style.display = 'none';
  if (note) note.style.display = '';

  // Navigation buttons
  document.getElementById('next1').addEventListener('click', () => {
    q1.style.display = 'none';
    if (note) note.style.display = 'none';
    q2.style.display = '';
  });

  document.getElementById('next2').addEventListener('click', () => {
    q2.style.display = 'none';
    q3.style.display = '';
  });

  document.getElementById('back2').addEventListener('click', () => {
    q2.style.display = 'none';
    q1.style.display = '';
    if (note) note.style.display = '';
  });

  document.getElementById('back3').addEventListener('click', () => {
    q3.style.display = 'none';
    q2.style.display = '';
  });

  document.getElementById('submitquiz').addEventListener('click', () => {
    PostAnswers2024_RenderShopify();
  });

});

/* -----------------------------
   Read selected radio value
--------------------------------*/
function getRadioVal(formEl, name) {
  if (!formEl) return undefined;

  const radios = formEl.elements[name];
  if (!radios) return undefined;

  if (radios.length === undefined) {
    return radios.checked ? radios.value : undefined;
  }

  for (let i = 0; i < radios.length; i++) {
    if (radios[i].checked) return radios[i].value;
  }
  return undefined;
}

/* -----------------------------------------------
   Original WP quiz logic: GetBreastPumpQuizResult2024
   ----------------------------------------------- */
function GetBreastPumpQuizResult2024(userAnswer) {

  var outputString = '';
  var group = [];
  var nocombo = '';

  // hospital grade groups
  var HGRO = ['453081', '494472', '506841', '497018']; 
  var HGRNO = ['453087']; 
  var HGPO = ['453789', '453799', '453081', '497018'];
  var HGPNO = ['453789', '453799'];

  // non hospital grade groups
  var NHGRO = ['453081', '444079', '447023', '506841'];
  var NHGRNO = ['453081', '444079', '447023', '506841', '453087'];
  var NHGPO = ['453081', '444079', '447023', '506841', '497018'];
  var NHGPNO = ['453789', '453799'];

  switch (userAnswer[0]) {
    case '0': // hospital grade
      if (userAnswer[1]=='1' && userAnswer[2]=='0') group = HGRO;
      else if (userAnswer[1]=='1' && userAnswer[2]=='1') group = HGRNO;
      else if (userAnswer[1]=='0' && userAnswer[2]=='1') group = HGPNO;
      else { group = HGPO; nocombo = 'none'; }
      break;

    case '1': // non-hospital grade
      if (userAnswer[1]=='1' && userAnswer[2]=='0') group = NHGRO;
      else if (userAnswer[1]=='1' && userAnswer[2]=='1') { group = NHGRNO; nocombo = 'none'; }
      else if (userAnswer[1]=='0' && userAnswer[2]=='1') { group = NHGPNO; nocombo = 'none'; }
      else { group = NHGPO; nocombo = 'none'; }
      break;
  }

  outputString = group.join(',');

  if (nocombo === 'none') {
    return outputString + '&combo=none';
  }

  return outputString;
}

/* ------------------------------------------------------------
   FINAL RESULT PROCESSING — Render inside Shopify
------------------------------------------------------------- */

// WP product IDs → Shopify product handles
var wpToShopifyMap = {
  '453081': 'spectra-dual-compact-rechargeable-double-electric-breast-pump-only',
  '453087': 'spectra-s1-pro-hospital-grade-double-electric-breast-pump',
  '453789': 'spectra-s2-pro-hospital-grade-double-electric-breast-pump',
  '453799': 'spectra-dual-s-hospital-grade-double-electric-breast-pump-only',
  '444079': 'wisemom-pocket-rechargeable-double-electric-breast-pump-new-breastkit-design-2',
  '447023': 'wisemom-on-the-go',
  '460553': 'wisemom-otg-bundle',
  '444070': 'youha-the-ins-gen-2-wearable-handsfree-breast-pump-with-bluetooth',
  '494472' : 'naim-hospital-grade-wearable-breast-pump',
  '506841' : 'naim-plus',
  '497018' : 'spectra-wearable-breast-pump-24mm'
};

function PostAnswers2024_RenderShopify() {

  // gather answers
  const userAnswer = [];
  userAnswer[0] = getRadioVal(document.getElementById('howoftenform'), 'howoften');
  userAnswer[1] = getRadioVal(document.getElementById('rechargeableform'), 'rechargeable');
  userAnswer[2] = getRadioVal(document.getElementById('hospitalgradeform'), 'hospitalgrade');

  let quizResult = GetBreastPumpQuizResult2024(userAnswer);

  if (!quizResult) return renderNoMatch();

  let combo = null;
  if (quizResult.includes('&combo=')) {
    const parts = quizResult.split('&');
    quizResult = parts[0];
    combo = parts[1].replace('combo=', '');
  }

  const prodIds = quizResult.split(',').filter(Boolean);
  const handles = prodIds.map(id => wpToShopifyMap[id]).filter(Boolean);

  // Prepare UI
  const resultBox = document.getElementById('quizresults');
  const listEl = document.getElementById('quizresults-list');
  const titleEl = document.getElementById('quizresults-title');

  resultBox.style.display = '';
  listEl.innerHTML = '';

  if (handles.length === 0) return renderNoMatch(prodIds);

  // Update title based on combo
  titleEl.textContent = combo === 'none'
    ? 'We cannot find an exact match. You may consider these pumps instead:'
    : 'We recommend the following breast pumps:';

  // Fetch each product from Shopify
  handles.forEach(handle => {
    fetch('/products/' + handle + '.js')
      .then(r => r.json())
      .then(prodJSON => renderProductCard(prodJSON, handle))
      .catch(() => {
        const note = document.createElement('div');
        note.className = 'product-card';
        note.textContent = 'Product not found: ' + handle;
        listEl.appendChild(note);
      });
  });
}

/* -------------------------------------------
   RENDER PRODUCT CARD (with ATC + variants)
-------------------------------------------- */
function renderProductCard(prodJSON, handle) {
  const listEl = document.getElementById('quizresults-list');

  const card = document.createElement('div');
  card.className = 'product-card enhanced-product-card';

  // Image
  const img = document.createElement('img');
  img.src = prodJSON.images?.[0] || '';
  img.alt = prodJSON.title || '';
  img.className = 'product-card-image';

  // Title
  const title = document.createElement('h3');
  title.textContent = prodJSON.title;
  title.className = 'product-card-title';

  // Price
  const price = document.createElement('p');
  price.textContent = '₱ ' + (prodJSON.price / 100).toFixed(2);
  price.className = 'product-card-price';

// Variant selector
const variantWrap = document.createElement('div');
variantWrap.className = 'variant-wrap';

const variantSelect = document.createElement('select');
variantSelect.className = 'variant-select';

// Find first available variant
let firstAvailableVariant = prodJSON.variants.find(v => v.available);

// Build dropdown
prodJSON.variants.forEach(v => {

  const opt = document.createElement('option');
  opt.value = v.id;

  if (!v.available) {
    opt.textContent = v.title + ' - Out of Stock';
    opt.disabled = true;
  } else {
    opt.textContent = v.title;
  }

  // Auto-select first available variant
  if (firstAvailableVariant && v.id === firstAvailableVariant.id) {
    opt.selected = true;
  }

  variantSelect.appendChild(opt);
});

// Hide dropdown if only 1 variant
if (prodJSON.variants.length === 1) {
  variantWrap.style.display = 'none';
} else {
  variantWrap.appendChild(variantSelect);
}

// ADD TO CART BUTTON
const atcBtn = document.createElement('button');
atcBtn.className = 'add-to-cart-btn';

// Initial button state
if (!firstAvailableVariant) {
  atcBtn.textContent = 'Out of Stock';
  atcBtn.disabled = true;
} else {
  atcBtn.textContent = 'Add to Cart';
}

// When variant changes
variantSelect.addEventListener('change', () => {

  const selectedVariant = prodJSON.variants.find(
    v => v.id == variantSelect.value
  );

  if (!selectedVariant.available) {
    atcBtn.textContent = 'Out of Stock';
    atcBtn.disabled = true;
  } else {
    atcBtn.textContent = 'Add to Cart';
    atcBtn.disabled = false;
  }

});

// Add to cart
atcBtn.addEventListener('click', () => {

  const selectedVariantId =
    prodJSON.variants.length === 1
      ? prodJSON.variants[0].id
      : variantSelect.value;

  const selectedVariant = prodJSON.variants.find(
    v => v.id == selectedVariantId
  );

  if (!selectedVariant.available) return;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: selectedVariantId,
      quantity: 1
    })
  })
  .then(r => r.json())
  .then(() => {

    atcBtn.textContent = 'Added!';
    atcBtn.classList.add('added');

    setTimeout(() => {
      atcBtn.textContent = 'Add to Cart';
      atcBtn.classList.remove('added');
    }, 1500);

  })
  .catch(() => {
    atcBtn.textContent = 'Error';
  });

});

  // View product link
  const link = document.createElement('a');
  link.href = prodJSON.url;
  link.textContent = 'View Product';
  link.className = 'product-link';

  // Build card
  card.appendChild(img);
  card.appendChild(title);
  card.appendChild(price);
  card.appendChild(variantWrap);
  card.appendChild(atcBtn);
  card.appendChild(link);

  listEl.appendChild(card);
}

/* -------------------------
   NO MATCH fallback UI
-------------------------- */
function renderNoMatch(prodIds) {
  const box = document.getElementById('quizresults');
  const list = document.getElementById('quizresults-list');
  const title = document.getElementById('quizresults-title');

  box.style.display = '';
  list.innerHTML = '';
  title.textContent = 'We cannot find a match. Please update product mapping.';

  const msg = document.createElement('p');
  msg.textContent = 'No matching Shopify products were found.';
  list.appendChild(msg);

  if (prodIds) {
    const idNote = document.createElement('small');
    idNote.textContent = 'WP product IDs: ' + prodIds.join(', ');
    list.appendChild(idNote);
  }
}